import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
const RichTextEditor = ({ disabled = false, value, uploadsHandler, onChange, onError, }) => {
    const editorRef = useRef(null);
    const mediaUploadHandler = useCallback((onSuccess, value, meta) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*, video/*');
        input.onchange = async (event) => {
            var _a;
            try {
                const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                if (file) {
                    const url = await uploadsHandler({ file, onProgress: () => { } });
                    onSuccess(url, { text: file.name });
                }
            }
            catch (e) {
                onError(e);
            }
        };
        input.click();
    }, [uploadsHandler, onError]);
    return (_jsx(Editor, { ref: editorRef, disabled: disabled, value: value, apiKey: process.env.TINY_MCE_API_KEY, init: {
            file_picker_callback: mediaUploadHandler,
            width: '100%',
            height: '100%',
            menubar: 'edit view insert format table',
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'code',
                'insertdatetime',
                'media',
                'table',
                'code',
                'wordcount',
            ],
            toolbar: 'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat',
        }, onEditorChange: onChange }));
};
RichTextEditor.defaultProps = {
    disabled: false,
    value: '',
    uploadsHandler: undefined,
    onChange: () => { },
    onError: () => { },
};
export default memo(RichTextEditor);
